import * as Sentry from '@sentry/angular';
import { environment } from './environments/environment';

export function initSentry() {
  if (!environment.sentry?.dsn) return;

  Sentry.init({
    dsn: environment.sentry.dsn,
    environment: environment.sentry.environment,
    tracesSampleRate: environment.sentry.tracesSampleRate,
    integrations: [
      Sentry.browserTracingIntegration()
    ],
    sendDefaultPii: true, // omogućuje breadcrumbs i IP context
  });

  Sentry.addBreadcrumb({
    category: 'init',
    message: 'Sentry initialized',
    level: 'info',
  });
}
